"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const helpers_1 = require("@/app/shared/helpers");
const redux_1 = require("redux");
const actions_1 = require("./actions");
const constants_1 = require("./constants");
exports.initialState = {
    schedulerData: null,
    workspaceData: null,
    hostAvailability: [],
    hostMeetings: [],
    isSettingsOpened: false,
    showWeekends: false,
    schedulerParams: {},
    workspaceId: null,
    bookingPage: constants_1.DEFAULT_BOOKING_PAGE,
    availability: "OPEN" /* SchedulerAvailability.OPEN */,
    availabilityCustom: [],
    bufferCustom: [],
    availabilityRange: {},
    availabilityRollingWindow: 10,
    availabilityRollingExpiration: null,
    calendarStartAt: constants_1.DEFAULT_CALENDAR_START_AT,
    host: null,
    mainGuest: null,
    guests: [],
    upsertAction: null,
    bookAction: null,
    isSchedulerDataFetching: false,
    isWorkspaceDataFetching: false,
    isHostScheduleFetching: false,
    error: false,
    hostScheduleError: false,
    isCreateFetching: false,
    createError: null,
    isBookFetching: false,
    isBookSuccess: false,
    bookError: null,
    headerTab: "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */,
    locationItems: [],
    locationRoomsItems: [],
    locationResourcesItems: [],
    CEPTemplate: null,
    CEPTemplateOptions: [],
    membersData: [],
    isFetchingMembers: false,
    hasBuffer: false,
    defaultTemplateId: null,
    serviceDurationMinutes: null,
    serviceLocationWarning: null,
    hostLimitWarning: false,
    serviceDurations: null,
};
const schedulerData = (state = exports.initialState.schedulerData, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_SCHEDULER_DATA:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_SUCCESS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.UPDATE_SCHEDULER_DATA:
            return { ...state, ...action.payload };
        case actions_1.SUMOCEPSchedulerActionTypes.GET_ATTENDEES_SEARCH_SUCCESS:
            const attendees = [...(state?.attendees || []), ...action.payload].filter((attendee, index, self) => index === self.findIndex((t) => t.id === attendee.id));
            return {
                ...state,
                attendees,
                users: [...attendees, ...(state?.hosts || [])],
            };
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SEARCH_SUCCESS:
            const hosts = [...(state?.hosts || []), ...action.payload].filter((host, index, self) => index === self.findIndex((t) => t.id === host.id));
            return {
                ...state,
                hosts,
                users: [...(state?.attendees || []), ...hosts],
            };
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SERVICES_SEARCH_SUCCESS:
            return {
                ...state,
                servicesOptions: [...(state?.servicesOptions || []), ...action.payload].filter((service, index, self) => index === self.findIndex((t) => t.value === service.value)),
            };
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.schedulerData;
        default:
            return state;
    }
};
const workspaceData = (state = exports.initialState.workspaceData, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_SUCCESS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
            return null;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.workspaceData;
        default:
            return state;
    }
};
const membersData = (state = exports.initialState.membersData, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.ADD_MEMBERS:
            return [
                ...state.filter((member) => member.type !== "CUSTOM" /* MemberType.CUSTOM */ || !action.payload.some((newMember) => (0, helpers_1.isSameEmail)(member.email, newMember.email))),
                ...action.payload,
            ];
        case actions_1.SUMOCEPSchedulerActionTypes.CLEAR_MEMBERS:
            return [];
        default:
            return state;
    }
};
const isFetchingMembers = (state = exports.initialState.isFetchingMembers, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.GET_MEMBERS_REQUEST:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_MEMBERS_SUCCESS:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_MEMBERS_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.CLEAR_MEMBERS:
            return false;
        default:
            return state;
    }
};
const hostAvailability = (state = exports.initialState.hostAvailability, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return action.payload === null ? exports.initialState.hostAvailability : state;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_SUCCESS:
            return action.payload === null ? exports.initialState.hostAvailability : action.payload.availability;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
            return [];
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.hostAvailability;
        default:
            return state;
    }
};
const hostMeetings = (state = exports.initialState.hostMeetings, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return action.payload === null ? exports.initialState.hostMeetings : state;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_SUCCESS:
            return action.payload === null ? exports.initialState.hostMeetings : action.payload.meetings;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
            return [];
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.hostMeetings;
        default:
            return state;
    }
};
const isSettingsOpened = (state = exports.initialState.isSettingsOpened, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_IS_SETTINGS_OPENED:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isSettingsOpened;
        default:
            return state;
    }
};
const showWeekends = (state = exports.initialState.showWeekends, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_SHOW_WEEKENDS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.showWeekends;
        default:
            return state;
    }
};
const schedulerParams = (state = exports.initialState.schedulerParams, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_SCHEDULER_PARAMS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.schedulerParams;
        default:
            return state;
    }
};
const workspaceId = (state = exports.initialState.workspaceId, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_WORKSPACE_ID:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_SUCCESS:
            return action.payload.workspaceId || state;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.workspaceId;
        default:
            return state;
    }
};
const bookingPage = (state = exports.initialState.bookingPage, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.UPDATE_BOOKING_PAGE:
            return { ...state, ...action.payload };
        case actions_1.SUMOCEPSchedulerActionTypes.UPDATE_BOOKING_PAGE_WHAT:
            return {
                ...state,
                what: {
                    ...state.what,
                    ...action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_MULTI_SERVICE_SELECTION:
            return {
                ...state,
                what: {
                    ...state.what,
                    serviceIds: action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.UPDATE_BOOKING_PAGE_WHERE:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_ROOM_AND_RESOURCES_SUCCESS:
            return {
                ...state,
                where: {
                    ...state.where,
                    ...action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.UPDATE_BOOKING_PAGE_WHEN:
            return {
                ...state,
                when: {
                    ...state.when,
                    ...action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_SCHEDULER_PARAMS:
            return {
                ...state,
                what: {
                    ...state.what,
                    customName: action.payload.subject,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_TIME_ZONE:
            return {
                ...state,
                calendar: {
                    ...state.calendar,
                    timeZone: action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_CEP_TEMPLATE:
            return {
                ...state,
                CEPTemplate: action.payload,
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_LIMIT:
            return {
                ...state,
                limit: action.payload,
                guestsLimit: action.payload === "UNLIMITED" /* SchedulerLimit.UNLIMITED */ ? undefined : parseInt(action.payload.replace('LIMIT', '')),
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY:
            return {
                ...state,
                when: {
                    ...state.when,
                    availability: action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY_CUSTOM:
            return {
                ...state,
                when: {
                    ...state.when,
                    customRanges: action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY_ROLLING_EXPIRATION:
            return {
                ...state,
                when: {
                    ...state.when,
                    expiresAt: action.payload ? new Date(action.payload[2], action.payload[1], action.payload[0]).toISOString() : null,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY_ROLLING_WINDOW:
            return {
                ...state,
                when: {
                    ...state.when,
                    dateRange: {
                        ...state.when?.dateRange || {},
                        type: "DAYS_IN_FUTURE" /* SUMOCEP_server.DateRangeType.DAYS_IN_FUTURE */,
                        count: action.payload,
                    }
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return {
                ...state,
                who: {
                    ...state.who,
                    hostMembers: [action.payload],
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_MAIN_GUEST:
            return {
                ...state,
                who: {
                    ...state.who,
                    mainGuest: action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.SET_GUESTS:
            return {
                ...state,
                who: {
                    ...state.who,
                    guests: action.payload,
                },
            };
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.bookingPage;
        default:
            return state;
    }
};
const availability = (state = exports.initialState.availability, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availability;
        default:
            return state;
    }
};
const availabilityCustom = (state = exports.initialState.availabilityCustom, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return action.payload === null ? exports.initialState.availabilityCustom : state;
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY_CUSTOM:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityCustom;
        default:
            return state;
    }
};
const bufferCustom = (state = exports.initialState.bufferCustom, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return action.payload === null ? exports.initialState.bufferCustom : state;
        case actions_1.SUMOCEPSchedulerActionTypes.SET_BUFFER_CUSTOM:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.bufferCustom;
        default:
            return state;
    }
};
const availabilityRange = (state = exports.initialState.availabilityRange, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.UPDATE_AVAILABILITY_RANGE:
            return { ...state, ...action.payload };
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityRange;
        default:
            return state;
    }
};
const availabilityRollingWindow = (state = exports.initialState.availabilityRollingWindow, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY_ROLLING_WINDOW:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityRollingWindow;
        default:
            return state;
    }
};
const availabilityRollingExpiration = (state = exports.initialState.availabilityRollingExpiration, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_AVAILABILITY_ROLLING_EXPIRATION:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityRollingExpiration;
        default:
            return state;
    }
};
const calendarStartAt = (state = exports.initialState.calendarStartAt, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_CALENDAR_START_AT:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.calendarStartAt;
        default:
            return state;
    }
};
const host = (state = exports.initialState.host, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.host;
        default:
            return state;
    }
};
const mainGuest = (state = exports.initialState.mainGuest, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_MAIN_GUEST:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return action.payload?.email && (0, helpers_1.isSameEmail)(state?.email, action.payload?.email) ? null : state;
        case actions_1.SUMOCEPSchedulerActionTypes.CLEAR_MEMBERS:
            return null;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.mainGuest;
        default:
            return state;
    }
};
const guests = (state = exports.initialState.guests, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_GUESTS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.SET_MAIN_GUEST:
            return action.payload?.email ? state.filter((guest) => !(0, helpers_1.isSameEmail)(guest.email, action.payload?.email)) : state;
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return action.payload?.email ? state.filter((guest) => !(0, helpers_1.isSameEmail)(guest.email, action.payload?.email)) : state;
        case actions_1.SUMOCEPSchedulerActionTypes.CLEAR_MEMBERS:
            return [];
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.guests;
        default:
            return state;
    }
};
const upsertAction = (state = exports.initialState.upsertAction, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_UPSERT_ACTION:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.upsertAction;
        default:
            return state;
    }
};
const bookAction = (state = exports.initialState.bookAction, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_BOOK_ACTION:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.bookAction;
        default:
            return state;
    }
};
const isSchedulerDataFetching = (state = exports.initialState.isSchedulerDataFetching, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_REQUEST:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_SUCCESS:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
            return false;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isSchedulerDataFetching;
        default:
            return state;
    }
};
const isWorkspaceDataFetching = (state = exports.initialState.isWorkspaceDataFetching, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_REQUEST:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_SUCCESS:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
            return false;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isWorkspaceDataFetching;
        default:
            return state;
    }
};
const isHostScheduleFetching = (state = exports.initialState.isHostScheduleFetching, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_REQUEST:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_SUCCESS:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
            return false;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isHostScheduleFetching;
        default:
            return state;
    }
};
const error = (state = exports.initialState.error, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_REQUEST:
        case actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_REQUEST:
            return false;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.error;
        default:
            return state;
    }
};
const hostScheduleError = (state = exports.initialState.hostScheduleError, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_REQUEST:
            return false;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.hostScheduleError;
        default:
            return state;
    }
};
const isCreateFetching = (state = exports.initialState.isCreateFetching, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_REQUEST:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_SUCCESS:
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_FAILURE:
            return false;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isCreateFetching;
        default:
            return state;
    }
};
const createError = (state = exports.initialState.createError, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_FAILURE:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_REQUEST:
            return null;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.createError;
        default:
            return state;
    }
};
const isBookFetching = (state = exports.initialState.isBookFetching, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_REQUEST:
            return true;
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_SUCCESS:
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_FAILURE:
            return false;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isBookFetching;
        default:
            return state;
    }
};
const isBookSuccess = (state = exports.initialState.isBookSuccess, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_BOOK_PAGE_SUCCESS_STATUS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isBookSuccess;
        default:
            return state;
    }
};
const bookError = (state = exports.initialState.bookError, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_FAILURE:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_REQUEST:
            return null;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.bookError;
        default:
            return state;
    }
};
const headerTab = (state = exports.initialState.headerTab, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HEADER_TAB:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.headerTab;
        default:
            return state;
    }
};
const locationItems = (state = exports.initialState.locationItems, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_LOCATION_ITEMS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.locationItems;
        default:
            return state;
    }
};
const locationRoomsItems = (state = exports.initialState.locationRoomsItems, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_LOCATION_ROOMS_ITEMS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_ROOM_AND_RESOURCES_SUCCESS:
            return action.payload.rooms;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.locationRoomsItems;
        default:
            return state;
    }
};
const locationResourcesItems = (state = exports.initialState.locationResourcesItems, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_LOCATION_RESOURCES_ITEMS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.GET_ROOM_AND_RESOURCES_SUCCESS:
            return action.payload.resources;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.locationResourcesItems;
        default:
            return state;
    }
};
const CEPTemplate = (state = exports.initialState.CEPTemplate, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_CEP_TEMPLATE:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.CEPTemplate;
        default:
            return state;
    }
};
const CEPTemplateOptions = (state = exports.initialState.CEPTemplateOptions, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_CEP_TEMPLATE_OPTIONS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.CEPTemplateOptions;
        default:
            return state;
    }
};
const hasBuffer = (state = exports.initialState.hasBuffer, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HAS_BUFFER:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.UPDATE_BOOKING_PAGE_WHEN:
            return Boolean(helpers_1.bufferTimeConvert.fromStringToNumber(action.payload?.beforeStartTime) || helpers_1.bufferTimeConvert.fromStringToNumber(action.payload?.afterEndTime));
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.hasBuffer;
        default:
            return state;
    }
};
const defaultTemplateId = (state = exports.initialState.defaultTemplateId, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_DEFAULT_TEMPLATE_ID:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.defaultTemplateId;
        default:
            return state;
    }
};
const serviceDurationMinutes = (state = exports.initialState.serviceDurationMinutes, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_SERVICE_DURATION_MINUTES:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.serviceDurationMinutes;
        default:
            return state;
    }
};
const serviceLocationWarning = (state = exports.initialState.serviceLocationWarning, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_SERVICE_LOCATION_WARNING:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.SET_MULTI_SERVICE_SELECTION:
            return null;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.serviceLocationWarning;
        default:
            return state;
    }
};
const hostLimitWarning = (state = exports.initialState.hostLimitWarning, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST_LIMIT_WARNING:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.SET_HOST:
            return exports.initialState.hostLimitWarning;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.hostLimitWarning;
        default:
            return state;
    }
};
const serviceDurations = (state = exports.initialState.serviceDurations, action) => {
    switch (action.type) {
        case actions_1.SUMOCEPSchedulerActionTypes.SET_SERVICE_DURATIONS:
            return action.payload;
        case actions_1.SUMOCEPSchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.serviceDurations;
        default:
            return state;
    }
};
exports.default = (0, redux_1.combineReducers)({
    schedulerData,
    workspaceData,
    hostAvailability,
    hostMeetings,
    isSettingsOpened,
    showWeekends,
    schedulerParams,
    workspaceId,
    bookingPage,
    availability,
    availabilityCustom,
    bufferCustom,
    availabilityRange,
    availabilityRollingWindow,
    availabilityRollingExpiration,
    calendarStartAt,
    host,
    mainGuest,
    guests,
    upsertAction,
    bookAction,
    isSchedulerDataFetching,
    isWorkspaceDataFetching,
    error,
    isHostScheduleFetching,
    hostScheduleError,
    isCreateFetching,
    createError,
    isBookFetching,
    isBookSuccess,
    bookError,
    headerTab,
    locationItems,
    locationRoomsItems,
    locationResourcesItems,
    CEPTemplate,
    CEPTemplateOptions,
    membersData,
    isFetchingMembers,
    hasBuffer,
    defaultTemplateId,
    serviceDurationMinutes,
    serviceLocationWarning,
    hostLimitWarning,
    serviceDurations,
});
